// Helper functions for host-related operations

/**
 * Get the current host ID from localStorage
 * This is used when properties don't have a hostId assigned
 */
export const getCurrentHostId = () => {
  try {
    // First, try to get from a stored "default host" key
    const defaultHostId = localStorage.getItem('defaultHostId');
    if (defaultHostId) {
      return defaultHostId;
    }

    // If not found, try to get from current user if they're a host
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const user = JSON.parse(storedUser);
      const role = String(user.role || '');
      const isHostUser = ['host', 'company_admin', 'company_manager', 'company_staff'].includes(role) || Boolean(user?.company?._id || user?.company);
      if (isHostUser) {
        const hostId = user._id || user.id;
        // Save as default for future use
        localStorage.setItem('defaultHostId', hostId);
        return hostId;
      }
    }

    // Fallback to demo_host
    return 'demo_host';
  } catch (error) {
    console.error('Error getting host ID:', error);
    return 'demo_host';
  }
};

/**
 * Set the default host ID
 * Call this when a host logs in
 */
export const setDefaultHostId = (hostId) => {
  try {
    localStorage.setItem('defaultHostId', hostId);
    console.log('✅ Default host ID set to:', hostId);
  } catch (error) {
    console.error('Error setting default host ID:', error);
  }
};

/**
 * Get host ID for a property
 * Returns the property's hostId or the default host ID
 */
export const getPropertyHostId = (property) => {
  const hostId = property.hostId || 
         property.host?._id || 
         property.host?.id || 
         getCurrentHostId();
  
  console.log('🔍 getPropertyHostId called');
  console.log('  Property:', property?.name || 'Unknown');
  console.log('  Property hostId:', property.hostId);
  console.log('  Property host._id:', property.host?._id);
  console.log('  Default hostId:', getCurrentHostId());
  console.log('  ✅ Using hostId:', hostId);
  
  return hostId;
};

/**
 * Assign current host to all properties without a hostId
 * Call this when host logs in to claim unassigned properties
 */
export const assignHostToProperties = (hostId) => {
  try {
    // This would be done on the backend in production
    // For demo, we just set the default host ID
    setDefaultHostId(hostId);
    console.log('✅ Host', hostId, 'will receive notifications for all properties');
  } catch (error) {
    console.error('Error assigning host to properties:', error);
  }
};

export default {
  getCurrentHostId,
  setDefaultHostId,
  getPropertyHostId,
  assignHostToProperties
};
